import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormElementsService} from '../../services/form-elements.service';
import {AutocompleteComponent} from '../autocomplete/autocomplete.component';
import {VtcCitation} from '../../../forms/modules/vtc/models/vtc';
import {VupchCitation} from '../../../forms/modules/vupch/models/vupch';

@Component({
  selector: 'app-multiline-input',
  templateUrl: './multiline-input.component.html',
  styleUrls: ['./multiline-input.component.scss']
})
export class MultilineInputComponent extends AutocompleteComponent implements OnInit {
  public options: any;
  @Input() rows: number;
  @Input() height: number;
  @Input() lengthLimitation: number;
  @Output() objectChosen = new EventEmitter();
  protected optionObjects: any[];

  constructor(protected formElementsService: FormElementsService) {
    super(formElementsService);
  }

  ngOnInit(): void {
    this.actualValue = this.ngModelObject;
  }

  public setSelectedOption(event?: any): void {
    const valueToEmit = this.getValueToEmit(event);
    this.objectChosen.emit(this.getValueFromOptions(event));
    switch (this.inputId) {
      case 'VupchCitation.citingPublication':
        this.handleVupchCitation(valueToEmit);
        break;
      case 'VtcCitation.citingPublication':
        const emit = {} as VtcCitation;
        if (valueToEmit) {
          emit.citingPublication = valueToEmit?.detail;
          emit.idEpcPublication = valueToEmit?.idEpcPublication;
          emit.idEpcCitation = valueToEmit.idEpcCitation;
        }
        this.emitValue(emit, this.objectToSet !== null);
        break;
      case 'Vtc.idEpcPublication':
        this.emitValue(valueToEmit?.detail, true);
        break;
      default:
        this.emitValue(valueToEmit, this.objectToSet !== null);
        break;
    }
  }

  private handleVupchCitation(valueToEmit): void {
    const previousObject = this.formObject[this.objectToSet[0]][this.objectToSet[1]];
    const emit = {
      idEpcCitation: valueToEmit?.idEpcCitation,
      idEpcPublication: previousObject.idEpcPublication,
      citedPublication: previousObject.citedPublication,
      citingPublication: valueToEmit?.detail,
    } as VupchCitation;

    this.emitValue(emit, this.objectToSet !== null);
  }

  onLanguageChange(language: 'SK' | 'EN'): void {
    this.selectedInputLanguage = language;
    this.actualValue = this.ngModelObject;
  }
}
